import { MEDIADATEN } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminMediadatenService = {
  getAll: () => requests.get(`${MEDIADATEN}`),

  create: (params: any) => requests.post(`${MEDIADATEN}`, params, true),
};
